"use client";

import { URLQuery } from "@/mono/lib/url";
import { useGlobalStore } from "@/mono/store/global";

import { useEffect } from "react";

import { setupEmitter } from "@/mono/lib/emitter";
import { gsap } from "@/mono/lib/gsap";
import { isMobile } from "@/mono/lib/platform";
import { isMobileLayout } from "@/mono/lib/responsive";
import useIsomorphicLayoutEffect from "./useIsomorphicLayoutEffect";
import { events } from "@/common/constants";
import useDetectCapabilitesAndSetupWorkers from "./useDetectCapabilites";
import Workers from "../webworkers/Workers";
import { isTabletOnlyLayout, isTabletOrSmallerLayout } from "../responsive";

export default function useProjectSetup() {
  // const { lenis } = useGlobalStore((s) => ({
  //   lenis: s.lenis,
  // }));
  useDetectCapabilitesAndSetupWorkers();

  useIsomorphicLayoutEffect(() => {
    const query = new URLQuery();
    const skipIntro = query.get("skipIntro");
    const isDebug = query.get("debug") || query.get("_debug");

    // const _lenis = new Lenis({
    //   smoothTouch: true,
    //   syncTouch: true,
    //   lerp: 0.08,
    //   touchMultiplier: 0.3,
    //   wheelMultiplier: 0.5,
    //   wheelEventsTarget: document.body,
    //   // easing: (t) => 1 - Math.pow(1 - t, 5),
    // });

    //_lenis.on("scroll", ScrollTrigger.update);

    const emitter = setupEmitter(query.get("debugEvents"));

    // TEMP:
    // emitter.emit(events.LOADING_DONE);

    // FIXME: For some reason this ticker.add gets
    // removed? We'll have to test useTicker a bit
    // gsap.ticker.add((time) => {
    //   _lenis.raf(time * 1000);
    // });
    // Enabling this causes events and update methods being called way too often ?
    gsap.ticker.lagSmoothing(0);

    useGlobalStore.setState({
      urlQuery: query,
      skipIntro,
      emitter,
      //lenis: _lenis,
      isDebug,
    });

    Workers.init();

    return () => {
      // _lenis.destroy();
      // useGlobalStore.setState({
      //   lenis: null,
      // });
      Workers.dispose();
    };
  }, []);

  function handleResize() {
    const width = Math.min(
      window.innerWidth,
      document.documentElement.clientWidth
    );
    const height = Math.min(
      window.innerHeight,
      document.documentElement.clientHeight
    );

    useGlobalStore.setState({
      windowSize: { width, height },
      isMobile: isMobile(),
      isTabletOnlyLayout: isTabletOnlyLayout(width),
      isTabletOrSmallerLayout: isTabletOrSmallerLayout(width),
      isMobileLayout: isMobileLayout(width),
    });
  }

  useEffect(() => {
    handleResize();
    window.scrollTo(0, 0);

    window.history.scrollRestoration = "manual";

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // useEvent(events.ROUTE_CHANGE_COMPLETE, () => {
  //   lenis?.reset();
  //   lenis?.resize();
  // });
}
